import { useEffect } from "react";
import BasicDataTable from "../../DataTable/BasicDataTable";
import BasicSearchComponent from "../../DataTable/BasicSearchComponent";
import { useProductColors } from "../../../hooks/product/useProductColors";
import ProductColorPopup from "./ProductColorPopup";

const ProductColorTable: React.FC = () => {
  const {
    productColors,
    fetchProductColors,
    handlerSearchColors,
    toggleProductColorStatus,
    loadProductColorForEdit,

    // modales
    isCreateModalOpen,
    isEditModalOpen,
    openCreateProductColor,
    closeCreateProductColor,
    closeEditProductColor,

    // form submit handler
    handlerAddProductColor,
  } = useProductColors();

  // ==========================================
  // LOAD on mount
  // ==========================================
  useEffect(() => {
    fetchProductColors();
  }, []);

  // ==========================================
  // TABLE COLUMNS
  // ==========================================
  const columns = [
    { Header: "Código", accessor: "code" },
    { Header: "Nombre", accessor: "name" },
    {
      Header: "Estado",
      accessor: "status",
      Cell: ({ value }) => (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            value ? "bg-green-500 text-white" : "bg-red text-white"
          }`}
        >
          {value ? "Activo" : "Inactivo"}
        </span>
      ),
    },
  ];

  // ==========================================
  // HEADER BUTTON
  // ==========================================
  const addButton = (
    <button
      className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
      onClick={openCreateProductColor}
    >
      + Nuevo Color
    </button>
  );

  // ==========================================
  // Actions
  // ==========================================
  const actions = [
    {
      key: "edit",
      onClick: (row: any) => {
        loadProductColorForEdit(row.id);
      },
    },
    {
      key: "toggle",
      onClick: (row: any) => {
        toggleProductColorStatus(row.id);
      },
    },
  ];

  return (
    <>
      <BasicDataTable
        columns={columns}
        data={productColors}
        noDataMessage="No hay colores registrados."
        actions={actions}
        headerButton={addButton}
        searchComponent={
          <BasicSearchComponent onSearch={(params) => handlerSearchColors(params.name)} />
        }
      />

      {/* CREATE MODAL */}
      <ProductColorPopup
        isOpen={isCreateModalOpen}
        close={closeCreateProductColor}
        onSubmit={handlerAddProductColor}
      />

      {/* EDIT MODAL */}
      <ProductColorPopup
        isOpen={isEditModalOpen}
        close={closeEditProductColor}
        onSubmit={handlerAddProductColor}
      />
    </>
  );
};

export default ProductColorTable;
